/* eslint-disable*/
import React, { useEffect, useState, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faChevronLeft,
  faChevronRight,
  faSearch,
  faRefresh,
  faPrint,
  faFileExport,
  faSort,
  faSortDown,
  faSortUp,
} from "@fortawesome/free-solid-svg-icons";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, useLocation } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { API_URL } from "../config";
import axios from "axios";
import { showToast } from "../components/toast";
import moment from "moment";
import AddOrderPopup from "./AddOrderPopup";
import { PermissionWrapper, hasPermission } from "../helpers/permission.js";
import BulkEditOrderPopup from "./BulkEditOrderPopup";
import { subMonths, startOfMonth } from "date-fns";
import usePersistedState from "../Subscriber/usePersistedState.jsx";
import MultiSelectDropdown from "../Subscriber/MultiSelectDropdown";
import "../Subscriber/MultiSelectDropdown.css";
import "./order.css";
import useDoubleScroll from "../helpers/useDoubleScroll";

const FieldPermissionWrapper = ({ field, children }) => {
  const hasFieldViewPermission = hasPermission(field, "view");
  return hasFieldViewPermission ? children : null;
};

// Helper function to parse single range string into min and max values
const parseNumericRange = (value) => {
  if (!value || typeof value !== "string") return { min: undefined, max: undefined };
  const trimmed = value.trim();
  if (!trimmed) return { min: undefined, max: undefined };

  // Match range like "100-200", "100 - 200", "100 to 200"
  const rangeMatch = trimmed.match(/^(\d+(?:\.\d+)?)\s*(?:-|to)\s*(\d+(?:\.\d+)?)$/i);
  if (rangeMatch) {
    return { min: rangeMatch[1], max: rangeMatch[2] };
  }

  // Match ">=100", ">100", "100+"
  const gteMatch = trimmed.match(/^(?:>=?|>)\s*(\d+(?:\.\d+)?)$/) || trimmed.match(/^(\d+(?:\.\d+)?)\+$/);
  if (gteMatch) {
    return { min: gteMatch[1], max: undefined };
  }

  // Match "<=200", "<200"
  const lteMatch = trimmed.match(/^(?:<=?|<)\s*(\d+(?:\.\d+)?)$/);
  if (lteMatch) {
    return { min: undefined, max: lteMatch[1] };
  }

  // Single number "100": set both min and max for exact match
  const singleMatch = trimmed.match(/^(\d+(?:\.\d+)?)$/);
  if (singleMatch) {
    return { min: singleMatch[1], max: singleMatch[1] };
  }

  return { min: undefined, max: undefined };
};

const Order = () => {
  const token = localStorage.getItem("authToken");
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dropdownsLoading, setDropdownsLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [printLoading, setPrintLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const limit = 100;
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [sortField, setSortField] = usePersistedState("order_sortField", ""); // example: 'created_on'
  const [sortOrder, setSortOrder] = usePersistedState("order_sortOrder", "desc"); // 'asc' or 'desc'
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const activeFilter = queryParams.get("filter");
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [isModalOpenBulkEdit, setIsModalOpenBulkEdit] = useState(false);
  const prevMonthStart = startOfMonth(subMonths(new Date(), 1));
  const [orderTotal, setOrderTotal] = useState({
    actual_amount: "0",
    amount_payable: "0",
    remaining_amt: "0",
    tax_amt: "0",
    discount_amt: 0
  });

  const handleCheckboxChange = (id, checked) => {
    if (checked) {
      setSelectedOrders((prev) => [...prev, id]);
    } else {
      setSelectedOrders((prev) => prev.filter((subId) => subId !== id));
    }
  };

  const sortBox = (field) => {
    if (sortField === field) {
      const newOrder = sortOrder === "asc" ? "desc" : "asc";
      setSortOrder(newOrder);
      fetchOrders(1); // refetch data on toggle
    } else {
      setSortField(field);
      setSortOrder("asc");
      fetchOrders(1); // refetch data on new field
    }
  };

  const getSortIcon = (field) => {
    if (sortField === field) {
      return sortOrder === "asc" ? faSortUp : faSortDown;
    }
    return faSort; // default icon for inactive columns
  };

  const [dropdownOptions, setDropdownOptions] = useState({
    offerTypeList: [],
    orderTypeList: [],
    orderSubscriptionTypeList: [],
    orderApprovallist: [],
    amountList: [],
    paymodeList: [],
    stateList: [],
    refundStatus: [],
    paymentSourceList: [],
    leadSourceList: [],
    assignedUserList: [],
    salesManagerList: [],
    utmSourceList: [],
    utmMediumList: [],
    utmCampaignList: [],
    utmContentList: [],
    utmTermList: [],
  });

  // Filter states
  const [joinDateFilter, setJoinDateFilter] = usePersistedState(
    "order_joinDateFilter",
    [null, null]
  );
  const [subIdFilter, setSubIdFilter] = usePersistedState(
    "order_subIdFilter",
    ""
  );
  const [nameFilter, setNameFilter] = usePersistedState("order_nameFilter", "");
  const [mobileFilter, setMobileFilter] = usePersistedState(
    "order_mobileFilter",
    ""
  );
  // Add after other filter states
  const [leadSourceFilter, setLeadSourceFilter] = usePersistedState(
    "order_leadSourceFilter",
    ""
  );
  const [paymentDateFilter, setPaymentDateFilter] = usePersistedState(
    "order_paymentDateFilter",
    [null, null]
  );
  const [orderDueDateFilter, setOrderDueDateFilter] = usePersistedState(
    "order_orderDueDateFilter",
    [null, null]
  );
  const [paymentSourceFilter, setPaymentSourceFilter] = usePersistedState(
    "order_paymentSourceFilter",
    [] // Changed to array for multi-select
  );
  const [subscriptionTypeFilter, setSubscriptionTypeFilter] = usePersistedState(
    "order_subscriptionTypeFilter",
    ""
  );
  const [salesManagerFilter, setSalesManagerFilter] = usePersistedState(
    "order_salesManagerFilter",
    ""
  );
  const [assignedUserFilter, setAssignedUserFilter] = usePersistedState(
    "order_assignedUserFilter",
    ""
  );
  const [orderApprovalFilter, setOrderApprovalFilter] = usePersistedState(
    "order_orderApprovalFilter",
    ""
  );
  const [orderIdFilter, setOrderIdFilter] = usePersistedState(
    "order_orderIdFilter",
    ""
  );
  const [orderTypeFilter, setOrderTypeFilter] = usePersistedState(
    "order_orderTypeFilter",
    ""
  );
  const [discountTypeFilter, setDiscountTypeFilter] = usePersistedState(
    "order_discountTypeFilter",
    ""
  );
  const [discountCodeFilter, setDiscountCodeFilter] = usePersistedState(
    "order_discountCodeFilter",
    ""
  );
  const [transactionIdFilter, setTransactionIdFilter] = usePersistedState(
    "order_transactionIdFilter",
    ""
  );
  const [productAppFilter, setProductAppFilter] = usePersistedState(
    "order_productAppFilter",
    ""
  );

  const [utmSourceFilter, setUtmSourceFilter] = usePersistedState(
    "order_utmSourceFilter",
    ""
  );
  const [utmMediumFilter, setUtmMediumFilter] = usePersistedState(
    "order_utmMediumFilter",
    ""
  );
  const [utmCampaignFilter, setUtmCampaignFilter] = usePersistedState(
    "order_utmCampaignFilter",
    ""
  );
  const [utmContentFilter, setUtmContentFilter] = usePersistedState(
    "order_utmContentFilter",
    ""
  );
  const [utmTermFilter, setUtmTermFilter] = usePersistedState(
    "order_utmTermFilter",
    ""
  );

  const [refundStatusFilter, setRefundStatusFilter] = usePersistedState(
    "order_refundStatusFilter",
    ""
  );

  const [refundDateFilter, setRefundDateFilter] = usePersistedState(
    "order_refundDateFilter",
    [null, null]
  );

  const [paidAmountFilter, setPaidAmountFilter] = usePersistedState(
    "order_paidAmountFilter",
    ""
  );
  const [actualAmountFilter, setActualAmountFilter] = usePersistedState(
    "order_actualAmountFilter",
    ""
  );
  const [discountAmountFilter, setDiscountAmountFilter] = usePersistedState(
    "order_discountAmountFilter",
    ""
  );
  const [taxAmountFilter, setTaxAmountFilter] = usePersistedState(
    "order_taxAmountFilter",
    ""
  );
  const [remainingAmountFilter, setRemainingAmountFilter] = usePersistedState(
    "order_remainingAmountFilter",
    ""
  );

  // Handle date picker change
  const handleJoinDateChange = (dates) => {
    setJoinDateFilter(dates);
  };

  // Handle date picker change
  const handlePaymentnDateChange = (dates) => {
    setPaymentDateFilter(dates);
  };

  const handleOrderDueDateChange = (dates) => {
    setOrderDueDateFilter(dates);
  };

  const handleRefundDateChange = (dates) => {
    setRefundDateFilter(dates);
  };

  // Modal state and form data
  const [isModalOpenAddOrderModal, setIsModalOpenAddOrder] = useState(false);

  // Toggle the modal open/close
  const toggleModal = () => {
    setIsModalOpenAddOrder(!isModalOpenAddOrderModal);
  };

  // Close the modal
  const closeModal = () => {
    setIsModalOpenAddOrder(false);
  };

  const buildFilterParams = () => {
    const filterParams = {};

    if (joinDateFilter && joinDateFilter[0]) {
      filterParams.screated_on = moment(joinDateFilter[0]).format("YYYY-MM-DD");
      filterParams.ecreated_on = moment(
        joinDateFilter[1] || joinDateFilter[0]
      ).format("YYYY-MM-DD");
    }
    if (subIdFilter) filterParams.subscriberorgid = subIdFilter;
    if (nameFilter) filterParams.fullname = nameFilter;
    if (mobileFilter) filterParams.mobileno = mobileFilter;
    if (leadSourceFilter) filterParams.lead_source = leadSourceFilter;
    if (paymentDateFilter && paymentDateFilter[0]) {
      filterParams.spayment_date = moment(paymentDateFilter[0]).format("YYYY-MM-DD");
      filterParams.epayment_date = moment(
        paymentDateFilter[1] || paymentDateFilter[0]
      ).format("YYYY-MM-DD");
    }
    if (orderDueDateFilter && orderDueDateFilter[0]) {
      filterParams.sorder_due_date = moment(orderDueDateFilter[0]).format("YYYY-MM-DD");
      filterParams.eorder_due_date = moment(
        orderDueDateFilter[1] || orderDueDateFilter[0]
      ).format("YYYY-MM-DD");
    }
    if (paymentSourceFilter && paymentSourceFilter.length > 0) {
      const paymentSources = paymentSourceFilter
        .filter((source) => source !== "" && source !== null && source !== undefined)
        .map((source) => String(source))
        .join(",");
      if (paymentSources) {
        filterParams.payment_source = paymentSources;
      }
    }
    if (subscriptionTypeFilter)
      filterParams.order_subscription_type = subscriptionTypeFilter;
    if (salesManagerFilter) filterParams.sales_manager = salesManagerFilter;
    if (assignedUserFilter) filterParams.assignedto = assignedUserFilter;
    if (orderApprovalFilter !== "" && orderApprovalFilter !== null && orderApprovalFilter !== undefined)
      filterParams.order_approval = orderApprovalFilter;
    if (orderIdFilter) filterParams.orderid = orderIdFilter;
    if (orderTypeFilter !== "" && orderTypeFilter !== null && orderTypeFilter !== undefined)
      filterParams.order_type = orderTypeFilter;
    if (discountTypeFilter !== "" && discountTypeFilter !== null && discountTypeFilter !== undefined)
      filterParams.offer_type = discountTypeFilter;
    if (discountCodeFilter) filterParams.offercode = discountCodeFilter;
    if (transactionIdFilter) filterParams.transactionid = transactionIdFilter;
    if (productAppFilter !== "" && productAppFilter !== null && productAppFilter !== undefined)
      filterParams.product_app = productAppFilter;
    if (refundStatusFilter !== "" && refundStatusFilter !== null && refundStatusFilter !== undefined)
      filterParams.order_status = refundStatusFilter;
    if (refundDateFilter && refundDateFilter[0]) {
      filterParams.srefund_date = moment(refundDateFilter[0]).format("YYYY-MM-DD");
      filterParams.erefund_date = moment(
        refundDateFilter[1] || refundDateFilter[0]
      ).format("YYYY-MM-DD");
    }
    if (utmSourceFilter) filterParams.utm_source = utmSourceFilter;
    if (utmMediumFilter) filterParams.utm_medium = utmMediumFilter;
    if (utmCampaignFilter) filterParams.utm_campaign = utmCampaignFilter;
    if (utmContentFilter) filterParams.utm_content = utmContentFilter;
    if (utmTermFilter) filterParams.utm_term = utmTermFilter;
    if (paidAmountFilter) {
      const range = parseNumericRange(paidAmountFilter);
      if (range.min !== undefined) filterParams.min_paid_amount = range.min;
      if (range.max !== undefined) filterParams.max_paid_amount = range.max;
    }
    if (actualAmountFilter) {
      const range = parseNumericRange(actualAmountFilter);
      if (range.min !== undefined) filterParams.min_actual_amount = range.min;
      if (range.max !== undefined) filterParams.max_actual_amount = range.max;
    }
    if (discountAmountFilter) {
      const range = parseNumericRange(discountAmountFilter);
      if (range.min !== undefined) filterParams.min_discount_amt = range.min;
      if (range.max !== undefined) filterParams.max_discount_amt = range.max;
    }
    if (taxAmountFilter) {
      const range = parseNumericRange(taxAmountFilter);
      if (range.min !== undefined) filterParams.min_tax_amt = range.min;
      if (range.max !== undefined) filterParams.max_tax_amt = range.max;
    }
    if (remainingAmountFilter) {
      const range = parseNumericRange(remainingAmountFilter);
      if (range.min !== undefined) filterParams.min_remaining_amt = range.min;
      if (range.max !== undefined) filterParams.max_remaining_amt = range.max;
    }
    if (sortField) filterParams.orderbycol = sortField;
    if (sortOrder) filterParams.orderby = sortOrder;

    return filterParams;
  };

  const handleRowClick = (id) => {
    if (!hasPermission("orders", "view")) {
      return;
    }

    const filterParams = buildFilterParams();

    navigate(`/Order/Edit/${id}`, {
      state: {
        filterParams: filterParams,
      },
    });
  };

  const fetchOrders = async (pageNumber = 1) => {
    try {
      setLoading(true);
      setError(null);

      const filterParams = buildFilterParams();

      const response = await axios.post(
        `${API_URL}orders?limit=${limit}&page=${pageNumber}`,
        filterParams,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        const { orders, totalCount, filteredCount, orderTotal } = response.data.data;
        setOrders(orders || []);
        setFilteredOrders(orders || []);
        // setTotalRecords(totalCount);
        setTotalRecords(filteredCount);
        setTotalPages(Math.ceil(totalCount / limit)); // <-- fix here
        setOrderTotal(orderTotal || { // Store the order total
          actual_amount: "0",
          amount_payable: "0",
          remaining_amt: "0",
          tax_amt: "0",
          discount_amt: 0
        });
      } else {
        setError(response.data.message || "Failed to fetch orders");
        setOrders([]);
        setFilteredOrders([]);
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
      setError(error.message || "An error occurred while fetching orders");
      setOrders([]);
      setFilteredOrders([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchDropdownOptions = async () => {
    try {
      setDropdownsLoading(true);
      const response = await axios.get(`${API_URL}orders/get-dropdown`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.success && response.data.data) {

        const paymentSourceOptions = [
          { value: "1", label: "SG - WEB" },
          { value: "2", label: "SG - Mobile" },
          { value: "3", label: "SF - WEB" },
          { value: "4", label: "SF - Mobile" },
          { value: "0", label: "RP - Links" },
          { value: "5", label: "CRM" },
        ];
        setDropdownOptions({
          offerTypeList: response.data.data.offertypelist || [],
          orderTypeList: response.data.data.ordertypelist || [],
          orderSubscriptionTypeList:
            response.data.data.orderSubscriptionTypelist || [],
          orderApprovallist: response.data.data.orderApprovallist || [],
          amountList: response.data.data.amountlist || [],
          paymodeList: response.data.data.paymodelist || [],
          stateList: response.data.data.statelist || [],
          assignedUserList: response.data.data.assignedto_userlist || [],
          salesManagerList: response.data.data.sales_manager_userlist || [],
          refundStatus: response.data.data.refundStatus || [],
          paymentSourceList: paymentSourceOptions,
          leadSourceList: response.data.data.leadSource || [],
        });

        // Also fetch UTM dropdowns from subscriber API as requested
        const subResponse = await axios.get(`${API_URL}subscriber/get-dropdown`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (subResponse.data.success && subResponse.data.data) {
          setDropdownOptions(prev => ({
            ...prev,
            utmSourceList: subResponse.data.data.utmSource || [],
            utmMediumList: subResponse.data.data.utmMedium || [],
            utmCampaignList: subResponse.data.data.utmCampaign || [],
            utmContentList: subResponse.data.data.utmContent || [],
            utmTermList: subResponse.data.data.utmTerm || [],
          }));
        }
      }
    } catch (error) {
      console.error("Error fetching dropdown options:", error);
    } finally {
      setDropdownsLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders(page);
  }, [
    page,
    subscriptionTypeFilter,
    salesManagerFilter,
    assignedUserFilter,
    orderApprovalFilter,
    orderTypeFilter,
    discountTypeFilter,
    productAppFilter,
    refundStatusFilter,
    // refundDateFilter,
    paymentSourceFilter,
    paymentSourceFilter,
    leadSourceFilter,
    utmSourceFilter,
    utmMediumFilter,
    utmCampaignFilter,
    utmContentFilter,
    utmTermFilter,
  ]);

  // Listen for clear filter event from Sidebar
  useEffect(() => {
    const handleClearFilters = () => {
      setJoinDateFilter([null, null]);
      setSubIdFilter("");
      setNameFilter("");
      setMobileFilter("");
      setLeadSourceFilter("");
      setPaymentDateFilter([null, null]);
      setOrderDueDateFilter([null, null]);
      setPaymentSourceFilter([]);
      setSubscriptionTypeFilter("");
      setSalesManagerFilter("");
      setAssignedUserFilter("");
      setOrderApprovalFilter("");
      setOrderIdFilter("");
      setOrderTypeFilter("");
      setDiscountTypeFilter("");
      setDiscountCodeFilter("");
      setTransactionIdFilter("");
      setProductAppFilter("");
      setRefundStatusFilter("");
      setRefundStatusFilter("");
      setRefundDateFilter([null, null]);
      setUtmSourceFilter("");
      setUtmMediumFilter("");
      setUtmCampaignFilter("");
      setUtmContentFilter("");
      setUtmTermFilter("");
      setPaidAmountFilter("");
      setActualAmountFilter("");
      setDiscountAmountFilter("");
      setTaxAmountFilter("");
      setRemainingAmountFilter("");
      setPage(1);
    };

    window.addEventListener('clearOrderFiltersEvent', handleClearFilters);
    return () => {
      window.removeEventListener('clearOrderFiltersEvent', handleClearFilters);
    };
  }, []);

  useEffect(() => {
    fetchDropdownOptions();
  }, []);

  useEffect(() => {
    setPage(1);

    // Clear previous order approval filter first
    setOrderApprovalFilter("");

    // Only set new filter if activeFilter exists and is valid
    if (activeFilter) {
      const normalize = (s) => (s || "").toLowerCase();
      if (normalize(activeFilter) === "approved") {
        const found = dropdownOptions.orderApprovallist.find(
          (opt) =>
            normalize(opt.label) === "approved" || String(opt.value) === "1"
        );
        setOrderApprovalFilter(found ? String(found.value) : "1");
      } else if (normalize(activeFilter) === "pending") {
        const found = dropdownOptions.orderApprovallist.find(
          (opt) => normalize(opt.label) === "pending" || String(opt.value) === "0"
        );
        setOrderApprovalFilter(found ? String(found.value) : "0");
      }
    }
  }, [activeFilter, dropdownOptions]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, totalRecords);

  const handleActionChange = async (action) => {
    if (action === "delete") {
      if (selectedOrders.length === 0) {
        showToast.warning("Please select at least one order to delete");
        return;
      }
      if (!hasPermission("orders", "delete")) {
        showToast.warning("You don't have permission to delete orders");
        return;
      }

      if (
        window.confirm(
          `Are you sure you want to delete ${selectedOrders.length} order(s)?`
        )
      ) {
        try {
          const payload = {
            orderids: selectedOrders,
          };

          const response = await axios.put(
            `${API_URL}orders/bulk-delete`,
            payload,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                "Content-Type": "application/json",
              },
            }
          );

          console.log("Delete order", response);

          if (response.data.success === true) {
            showToast.success(
              response.data.message || "Orders deleted successfully"
            );
            setSelectedOrders([]);
            fetchOrders();
          }
        } catch (error) {
          console.error("Error deleting orders:", error);
          console.log(error.response?.data || "Unknown error");
          showToast.error("An error occurred while deleting orders");
        }
      }
    } else if (action === "bulkEdit") {
      if (!hasPermission("orders", "edit")) {
        showToast.warning("You don't have permission to edit orders");
        return;
      }
      if (selectedOrders.length === 0) {
        showToast.warning("Please select at least one order to edit");
        return;
      }
      setIsModalOpenBulkEdit(true);
    }
  };

  const handleAddOrderData = async (orderData) => {
    const payload = {
      subscriberid: orderData.subscriberid,
      orderid: orderData.order,
      pending_amount: orderData.pending_amount,
      order_type: parseInt(orderData.order_type),
      actual_amount: parseInt(orderData.actual_amount),
      pending_amount: parseInt(orderData.pending_amount),
      discount_amount: parseInt(orderData.discount_amount),
      paid_amount: parseInt(orderData.paid_amount),
      pay_date: orderData.payment_date,
      order_due_date: orderData.order_due_date,
      pay_mode: orderData.payment_mode,
      pay_refno: orderData.payment_reference,
      billedto: orderData.billed_to,
      gstin: orderData.gst_no,
      state_code: String(orderData.state),
      referralcode: orderData.referralcode || null,
    };

    try {
      const response = await axios.post(
        `${API_URL}orders/save-order-popup`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.success) {
        showToast.success(response.data.message);
        setIsModalOpenAddOrder(false);
      }
    } catch (error) {
      showToast.error(error);
    }
  };

  const handleExportReport = async () => {
    try {
      setExportLoading(true);
      const token = localStorage.getItem("authToken");
      const filterParams = buildFilterParams();

      const response = await axios.post(
        `${API_URL}orders/export-single-sheet`,
        filterParams,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          responseType: "blob", // important
        }
      );

      if (response.status === 201 || response.status === 200) {
        // Create a Blob from the response
        const blob = new Blob([response.data], {
          type: response.headers["content-type"] || "application/octet-stream",
        });

        // Generate dynamic file name
        const now = new Date();
        const formatDatePart = (n) => String(n).padStart(2, "0");

        const day = formatDatePart(now.getDate());
        const month = formatDatePart(now.getMonth() + 1);
        const year = now.getFullYear();

        let hours = now.getHours();
        const minutes = formatDatePart(now.getMinutes());
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;
        const hourStr = formatDatePart(hours);

        const fileName = `Orders-${day}_${month}_${year}_${hourStr}_${minutes}_${ampm}.xlsx`;

        // Create download link
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();

        // Cleanup
        window.URL.revokeObjectURL(link.href);

        showToast.success("Report exported successfully");
      } else {
        showToast.error("Failed to export report");
      }
    } catch (error) {
      console.error("Export error:", error);
      if (error.response?.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          const errObj = JSON.parse(text);
          showToast.error(errObj.message || "Failed to export report");
        } catch {
          showToast.error("An error occurred while exporting report");
        }
      } else {
        showToast.error("An error occurred while exporting report");
      }
    } finally {
      setExportLoading(false);
    }
  };

  const handlePrintAllInvoices = async () => {
    try {
      setPrintLoading(true);
      const token = localStorage.getItem("authToken");

      // First, fetch the invoice HTML
      const response = await axios.get(`${API_URL}orders/print-all`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "text", // Expect HTML response
      });

      if (response.status === 200) {
        // Open a new window with the invoice HTML
        const printWindow = window.open("", "_blank");
        if (!printWindow) {
          throw new Error("Popup blocked. Please allow popups for this site.");
        }

        printWindow.document.open();
        printWindow.document.write(response.data);
        printWindow.document.close();

        // Wait for the content to load before printing
        printWindow.onload = () => {
          setTimeout(() => {
            printWindow.focus();
            printWindow.print();
            setPrintLoading(false);
          }, 500);
        };
      } else {
        throw new Error("Failed to fetch invoices");
      }
    } catch (error) {
      console.error("Print error:", error);
      showToast.error(
        error.message || "An error occurred while printing invoices"
      );
      setPrintLoading(false);
    }
  };

  // function hasAnyFilter() {
  //   return (
  //     (joinDateFilter[0] && joinDateFilter[1]) ||
  //     subIdFilter ||
  //     nameFilter ||
  //     mobileFilter ||
  //     (paymentDateFilter[0] && paymentDateFilter[1]) ||
  //     subscriptionTypeFilter ||
  //     salesManagerFilter ||
  //     assignedUserFilter ||
  //     orderApprovalFilter ||
  //     orderIdFilter ||
  //     orderTypeFilter ||
  //     discountTypeFilter ||
  //     discountCodeFilter ||
  //     transactionIdFilter ||
  //     sortField ||
  //     sortOrder
  //   );
  // }

  function hasAnyFilter() {
    return (
      (joinDateFilter && joinDateFilter[0] !== null) ||
      subIdFilter !== "" ||
      nameFilter !== "" ||
      mobileFilter !== "" ||
      leadSourceFilter !== "" ||
      (paymentDateFilter && paymentDateFilter[0] !== null) ||
      (orderDueDateFilter && orderDueDateFilter[0] !== null) ||
      (paymentSourceFilter && paymentSourceFilter.length > 0) ||
      subscriptionTypeFilter !== "" ||
      salesManagerFilter !== "" ||
      assignedUserFilter !== "" ||
      orderApprovalFilter !== "" ||
      orderIdFilter !== "" ||
      orderTypeFilter !== "" ||
      discountTypeFilter !== "" ||
      discountCodeFilter !== "" ||
      transactionIdFilter !== "" ||
      productAppFilter !== "" ||
      refundStatusFilter !== "" ||
      (refundDateFilter && refundDateFilter[0] !== null) ||
      sortField !== "" ||
      sortOrder !== "desc" ||
      utmSourceFilter !== "" ||
      utmMediumFilter !== "" ||
      utmCampaignFilter !== "" ||
      utmContentFilter !== "" ||
      utmTermFilter !== "" ||
      paidAmountFilter !== "" ||
      actualAmountFilter !== "" ||
      discountAmountFilter !== "" ||
      taxAmountFilter !== "" ||
      remainingAmountFilter !== ""
    );
  }


  const tableContainerRef = useRef(null);
  const topScrollRef = useDoubleScroll(tableContainerRef);
  const getPaymentSourceLabel = (source) => {
    // Convert source to string for comparison
    const sourceStr = String(source);

    switch (sourceStr) {
      case "1": return "SG - WEB";
      case "2": return "SG - Mobile";
      case "3": return "SF - WEB";
      case "4": return "SF - Mobile";
      case "0": return "RP - Links";
      case "5": return "CRM";
      default: return "";
    }
  };

  return (
    <div className="panel-content mt-5">
      <div className="panel-heading d-flex justify-content-between">
        <div className="col-md-4">
          <div
            style={{ float: "left", position: "relative", marginLeft: "5px" }}
          >
            <select
              value="" // No value needed for action dropdown
              onChange={(e) => {
                const selectedAction = e.target.value;
                if (selectedAction) {
                  handleActionChange(selectedAction);
                }
              }}
              style={{
                width: "110px",
                padding: "0.25rem 0.5rem",
                fontSize: "0.875rem",
                lineHeight: "1.5",
                borderRadius: "0.2rem",
                border: "1px solid #ced4da",
                appearance: "none",
                backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e")`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right 0.5rem center",
                backgroundSize: "16px 12px",
              }}
            >
              <option value="">Action</option>
              <option value="delete">Delete Orders</option>

              <option value="bulkEdit">Bulk Edit</option>
            </select>
            {(hasAnyFilter() || activeFilter) && (
              <button
                className="btn btn-default btn-xs ml-1"
                style={{ marginLeft: "6px" }}
                onClick={() => {
                  // Clear all filter states
                  setJoinDateFilter([null, null]);
                  setSubIdFilter("");
                  setNameFilter("");
                  setMobileFilter("");
                  setLeadSourceFilter("");
                  setPaymentDateFilter([null, null]);
                  setOrderDueDateFilter([null, null]);
                  setPaymentSourceFilter([]);
                  setSubscriptionTypeFilter("");
                  setSalesManagerFilter("");
                  setAssignedUserFilter("");
                  setOrderApprovalFilter("");
                  setOrderIdFilter("");
                  setOrderTypeFilter("");
                  setDiscountTypeFilter("");
                  setDiscountCodeFilter("");
                  setTransactionIdFilter("");
                  setProductAppFilter("");
                  setRefundStatusFilter("");
                  setRefundDateFilter([null, null]);
                  setUtmSourceFilter("");
                  setUtmMediumFilter("");
                  setUtmCampaignFilter("");
                  setUtmContentFilter("");
                  setUtmTermFilter("");
                  setPaidAmountFilter("");
                  setActualAmountFilter("");
                  setDiscountAmountFilter("");
                  setTaxAmountFilter("");
                  setRemainingAmountFilter("");
                  setSortField("");
                  setSortOrder("asc");
                  setPage(1);

                  // Clear URL parameters if needed
                  if (activeFilter) {
                    navigate("/Order"); // Navigate to base URL without params
                  }

                  fetchOrders(1);
                }}
                title="Clear all filters"
              >
                Clear Filter
              </button>
            )}
          </div>
        </div>
        <div>
          <span style={{ fontSize: "0.8rem" }}>
            {start} to {end} of {totalRecords}
          </span>
          <button
            className="btn btn-default btn-sm mx-1"
            onClick={() => fetchOrders()}
          >
            <FontAwesomeIcon icon={faRefresh} />
          </button>
          <PermissionWrapper module="orders" action="add">
            <button
              className="btn btn-default btn-sm mx-1"
              onClick={toggleModal}
            >
              <FontAwesomeIcon icon={faPlus} /> Add Order
            </button>
          </PermissionWrapper>
          <PermissionWrapper module="orders" action="export">
            <button
              className="btn btn-default btn-sm mx-1"
              onClick={handleExportReport}
            >
              <FontAwesomeIcon icon={faFileExport} /> Export Report
            </button>
          </PermissionWrapper>
          <button
            className="btn btn-default btn-sm mx-1"
            onClick={handlePrintAllInvoices}
            disabled={printLoading}
          >
            <FontAwesomeIcon icon={faPrint} />
            {printLoading ? " Preparing..." : " Print All Invoice"}
          </button>
          <button
            className={`btn btn-default btn-sm ${page === 1 ? "d-none" : ""}`}
            title="Previous"
            onClick={() => handlePageChange(page - 1)}
            disabled={page === 1}
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
          &nbsp;
          <button
            className={`btn btn-default btn-sm ${page === totalPages ? "d-none" : ""
              }`}
            title="Next"
            onClick={() => handlePageChange(page + 1)}
            disabled={page === totalPages}
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
      </div>
      <div className="panel panel-default with-rounded-corner with-shadow">
        <div className="large-table-container-3">
          <div
            ref={topScrollRef}
            style={{
              overflowX: "auto",
              overflowY: "hidden",
              height: "16px",
              // width: "100%",
              marginBottom: "2px",
              background: "#f8f9fa",
            }}
          >
            {/* This inner div's width should match the table's width */}
            <div style={{ width: "100%", height: "1px" }}></div>
          </div>
          <div
            // style={{
            //   overflowY: "auto",
            //   maxHeight: "400px",
            //   overflowX: "auto", // For horizontal scrolling
            // }}
            ref={tableContainerRef}
            style={{
              overflowY: "auto",
              height: "calc(112vh - 250px)",
              overflowX: "auto",
              position: "relative",
            }}
          >
            <table className="table table-condensed table-hover bg-white sticky-table">
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        // Handle select all functionality
                        if (e.target.checked) {
                          // Select all orders on the current page
                          const allIds = filteredOrders.map(
                            (order) => order.id
                          );
                          setSelectedOrders(allIds);
                        } else {
                          // Deselect all subscribers
                          setSelectedOrders([]);
                        }
                      }}
                      checked={
                        filteredOrders.length > 0 &&
                        selectedOrders.length === filteredOrders.length
                      }
                    />
                  </th>
                  <th
                    style={{ minWidth: "155px", cursor: "pointer" }}
                    onClick={() => sortBox("created_on")}
                  >
                    Created Time{" "}
                    <FontAwesomeIcon icon={getSortIcon("created_on")} />
                  </th>
                  <th>Sub ID</th>
                  {/* Add this after the Mobile No FieldPermissionWrapper */}
                  <FieldPermissionWrapper field="lead_source">
                    <th style={{ minWidth: "155px", cursor: "pointer" }}
                      onClick={() => sortBox("lead_source")}>
                      Lead Source <FontAwesomeIcon icon={getSortIcon("lead_source")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_fullname">
                    <th
                      style={{ minWidth: "155px", cursor: "pointer" }}
                      onClick={() => sortBox("fullname")}
                    >
                      Subcriber Name{" "}
                      <FontAwesomeIcon icon={getSortIcon("fullname")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_mobileno">
                    <th
                      style={{ minWidth: "155px", cursor: "pointer" }}
                      onClick={() => sortBox("mobileno")}
                    >
                      Mobile No{" "}
                      <FontAwesomeIcon icon={getSortIcon("mobileno")} />
                    </th>
                  </FieldPermissionWrapper>


                  <th
                    style={{ minWidth: "155px", cursor: "pointer" }}
                    onClick={() => sortBox("payment_date")}
                  >
                    Payment Date{" "}
                    <FontAwesomeIcon icon={getSortIcon("payment_date")} />
                  </th>
                  <th
                    style={{ minWidth: "155px", cursor: "pointer" }}
                    onClick={() => sortBox("order_due_date")}
                  >
                    Order Due Date{" "}
                    <FontAwesomeIcon icon={getSortIcon("order_due_date")} />
                  </th>
                  <th
                    style={{ minWidth: "155px", cursor: "pointer" }}
                    onClick={() => sortBox("orderid")}
                  >
                    Order ID <FontAwesomeIcon icon={getSortIcon("orderid")} />
                  </th>
                  <FieldPermissionWrapper field="order_paid_amount">
                    <th
                      style={{ minWidth: "155px", cursor: "pointer" }}
                      onClick={() => sortBox("amount_payable")}
                    >
                      Paid Amt{" "}
                      <FontAwesomeIcon icon={getSortIcon("amount_payable")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="order_actual_amount">
                    <th
                      style={{ minWidth: "155px", cursor: "pointer" }}
                      onClick={() => sortBox("actual_amount")}
                    >
                      Actual Amount{" "}
                      <FontAwesomeIcon icon={getSortIcon("actual_amount")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="order_discount_amount">
                    <th
                      style={{ minWidth: "155px", cursor: "pointer" }}
                      onClick={() => sortBox("discount_amt")}
                    >
                      Discount Amount{" "}
                      <FontAwesomeIcon icon={getSortIcon("discount_amt")} />
                    </th>
                  </FieldPermissionWrapper>

                  <th
                    style={{ minWidth: "155px", cursor: "pointer" }}
                    onClick={() => sortBox("tax_amt")}
                  >
                    Tax Amount{" "}
                    <FontAwesomeIcon icon={getSortIcon("tax_amt")} />
                  </th>
                  <FieldPermissionWrapper field="remaining_amount">
                    <th
                      style={{ minWidth: "155px", cursor: "pointer" }}
                      onClick={() => sortBox("remaining_amt")}
                    >
                      Remaining Amount{" "}
                      <FontAwesomeIcon icon={getSortIcon("remaining_amt")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="service_category">
                    <th style={{ minWidth: "155px" }}>Service Category</th>
                  </FieldPermissionWrapper>
                  <th
                    style={{ minWidth: "155px", cursor: "pointer" }}
                    onClick={() => sortBox("order_subscription_type")}
                  >
                    Subscription Type{" "}
                    <FontAwesomeIcon
                      icon={getSortIcon("order_subscription_type")}
                    />
                  </th>
                  <FieldPermissionWrapper field="order_status">
                    <th
                      style={{ minWidth: "155px", cursor: "pointer" }}
                      onClick={() => sortBox("refund_status")}
                    >
                      Order Status{" "}
                      <FontAwesomeIcon icon={getSortIcon("refund_status")} />
                    </th>
                  </FieldPermissionWrapper>
                  <th
                    style={{ minWidth: "155px", cursor: "pointer" }}
                    onClick={() => sortBox("payment_source")}
                  >
                    Source{" "}
                    <FontAwesomeIcon icon={getSortIcon("payment_source")} />
                  </th>
                  <FieldPermissionWrapper field="refund_date">
                    <th
                      style={{ minWidth: "155px", cursor: "pointer" }}
                      onClick={() => sortBox("refund_date")}
                    >
                      Refund Date{" "}
                      <FontAwesomeIcon icon={getSortIcon("refund_date")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="refund_details">
                    <th
                      style={{ minWidth: "155px", cursor: "pointer" }}
                      onClick={() => sortBox("refund_details")}
                    >
                      Refund Details{" "}
                      <FontAwesomeIcon icon={getSortIcon("refund_details")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="order_sales_manager">
                    <th>Sales Manager </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="assign_to">
                    <th>Assigned User</th>
                  </FieldPermissionWrapper>

                  <FieldPermissionWrapper field="order_order_approval">
                    <th
                      style={{ minWidth: "155px", cursor: "pointer" }}
                      onClick={() => sortBox("order_approval")}
                    >
                      Order Approval{" "}
                      <FontAwesomeIcon icon={getSortIcon("order_approval")} />
                    </th>
                  </FieldPermissionWrapper>
                  <th>Parent / Child</th>
                  <FieldPermissionWrapper field="discount_type">
                    <th
                      style={{ minWidth: "155px", cursor: "pointer" }}
                      onClick={() => sortBox("offer_type")}
                    >
                      Discount Type{" "}
                      <FontAwesomeIcon icon={getSortIcon("offer_type")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="discount_code">
                    <th
                      style={{ minWidth: "155px", cursor: "pointer" }}
                      onClick={() => sortBox("offercode")}
                    >
                      Discount Code{" "}
                      <FontAwesomeIcon icon={getSortIcon("offercode")} />
                    </th>
                  </FieldPermissionWrapper>

                  <th
                    style={{ minWidth: "155px", cursor: "pointer" }}
                    onClick={() => sortBox("transactionid")}
                  >
                    Transaction ID{" "}
                    <FontAwesomeIcon icon={getSortIcon("transactionid")} />
                  </th>

                  <th style={{ minWidth: "150px" }}>UTM Source</th>
                  <th style={{ minWidth: "150px" }}>UTM Medium</th>
                  <th style={{ minWidth: "150px" }}>UTM Campaign</th>
                  <th style={{ minWidth: "150px" }}>UTM Content</th>
                  <th style={{ minWidth: "150px" }}>UTM Term</th>
                </tr>
                <tr>
                  <th></th>
                  <th>
                    <div className="d-flex align-items-center gap-1">
                      <DatePicker
                        selected={joinDateFilter[0]}
                        onChange={handleJoinDateChange}
                        startDate={joinDateFilter[0]}
                        endDate={joinDateFilter[1]}
                        selectsRange
                        isClearable
                        toggleCalendarOnIconClick
                        placeholderText=""
                        monthsShown={3}
                        openToDate={joinDateFilter[0] || new Date()} // Open at selected date if exists, else prevMonthStart
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        scrollableYearDropdown
                        yearDropdownItemNumber={15} // Shows 15 years in dropdown
                        minDate={new Date(2018, 0, 1)} // Start from 2018
                        maxDate={new Date(2030, 11, 31)}
                        dateFormat="dd-MM-yyyy" // Display format
                      />
                      <button
                        type="button"
                        className="btn btn-default btn-xs btn-group-xs"
                        onClick={() => fetchOrders()}
                      >
                        <FontAwesomeIcon icon={faSearch} />
                      </button>
                    </div>
                  </th>
                  <th>
                    <input
                      type="text"
                      placeholder=""
                      value={subIdFilter}
                      onChange={(e) => setSubIdFilter(e.target.value)}
                      style={{
                        // width: "90px",
                        padding: "5px",
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") fetchOrders();
                      }}
                    />
                  </th>
                  <FieldPermissionWrapper field="lead_source">
                    <th>
                      <select
                        value={leadSourceFilter}
                        onChange={(e) => setLeadSourceFilter(e.target.value)}
                        style={{ padding: "5px" }}
                      >
                        <option value="">--select--</option>
                        {dropdownOptions.leadSourceList &&
                          dropdownOptions.leadSourceList.map((item, index) => (
                            <option key={index} value={item.pick_name}>
                              {item.pick_name}
                            </option>
                          ))}
                      </select>
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_fullname">
                    <th>
                      <input
                        type="text"
                        placeholder=""
                        value={nameFilter}
                        onChange={(e) => setNameFilter(e.target.value)}
                        style={{
                          // width: "90px",
                          padding: "5px",
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") fetchOrders();
                        }}
                      />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_mobileno">
                    <th>
                      <input
                        type="text"
                        placeholder=""
                        value={mobileFilter}
                        onChange={(e) => setMobileFilter(e.target.value)}
                        style={{
                          // width: "90px",
                          padding: "5px",
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") fetchOrders();
                        }}
                      />
                    </th>
                  </FieldPermissionWrapper>

                  <th>
                    <div className="d-flex align-items-center gap-1">
                      <DatePicker
                        selected={paymentDateFilter[0]}
                        onChange={handlePaymentnDateChange}
                        startDate={paymentDateFilter[0]}
                        endDate={paymentDateFilter[1]}
                        selectsRange
                        isClearable
                        toggleCalendarOnIconClick
                        placeholderText=""
                        monthsShown={3}
                        openToDate={paymentDateFilter[0] || new Date()} // Open at selected date if exists, else prevMonthStart
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        scrollableYearDropdown
                        yearDropdownItemNumber={15} // Shows 15 years in dropdown
                        minDate={new Date(2018, 0, 1)} // Start from 2018
                        maxDate={new Date(2030, 11, 31)}
                        dateFormat="dd-MM-yyyy" // Display format
                      />
                      <button
                        type="button"
                        className="btn btn-default btn-xs btn-group-xs"
                        onClick={() => fetchOrders()}
                      >
                        <FontAwesomeIcon icon={faSearch} />
                      </button>
                    </div>
                  </th>
                  <th>
                    <div className="d-flex align-items-center gap-1">
                      <DatePicker
                        selected={orderDueDateFilter[0]}
                        onChange={handleOrderDueDateChange}
                        startDate={orderDueDateFilter[0]}
                        endDate={orderDueDateFilter[1]}
                        selectsRange
                        isClearable
                        toggleCalendarOnIconClick
                        placeholderText=""
                        monthsShown={3}
                        openToDate={orderDueDateFilter[0] || new Date()}
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        scrollableYearDropdown
                        yearDropdownItemNumber={15}
                        minDate={new Date(2018, 0, 1)}
                        maxDate={new Date(2030, 11, 31)}
                        dateFormat="dd-MM-yyyy"
                      />
                      <button
                        type="button"
                        className="btn btn-default btn-xs btn-group-xs"
                        onClick={() => fetchOrders()}
                      >
                        <FontAwesomeIcon icon={faSearch} />
                      </button>
                    </div>
                  </th>
                  <th>
                    <input
                      type="text"
                      placeholder=""
                      value={orderIdFilter}
                      onChange={(e) => setOrderIdFilter(e.target.value)}
                      style={{
                        padding: "5px",
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") fetchOrders();
                      }}
                    />
                  </th>
                  <FieldPermissionWrapper field="order_paid_amount">
                    <th>
                      <input
                        type="text"
                        placeholder="e.g. 1000-50000"
                        title="Enter single value or range (e.g. 1000-50000, >=1000, <=50000)"
                        value={paidAmountFilter}
                        onChange={(e) => setPaidAmountFilter(e.target.value)}
                        style={{
                          padding: "5px",
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") fetchOrders();
                        }}
                      />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="order_actual_amount">
                    <th>
                      <input
                        type="text"
                        placeholder="e.g. 1200-60000"
                        title="Enter single value or range (e.g. 1200-60000, >=1200, <=60000)"
                        value={actualAmountFilter}
                        onChange={(e) => setActualAmountFilter(e.target.value)}
                        style={{
                          padding: "5px",
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") fetchOrders();
                        }}
                      />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="order_discount_amount">
                    <th>
                      <input
                        type="text"
                        placeholder="e.g. 100-5000"
                        title="Enter single value or range (e.g. 100-5000, >=100, <=5000)"
                        value={discountAmountFilter}
                        onChange={(e) => setDiscountAmountFilter(e.target.value)}
                        style={{
                          padding: "5px",
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") fetchOrders();
                        }}
                      />
                    </th>
                  </FieldPermissionWrapper>
                  <th>
                    <input
                      type="text"
                      placeholder="e.g. 180-9000"
                      title="Enter single value or range (e.g. 180-9000, >=180, <=9000)"
                      value={taxAmountFilter}
                      onChange={(e) => setTaxAmountFilter(e.target.value)}
                      style={{
                        padding: "5px",
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") fetchOrders();
                      }}
                    />
                  </th>
                  <FieldPermissionWrapper field="remaining_amount">
                    <th>
                      <input
                        type="text"
                        placeholder="e.g. 0-10000"
                        title="Enter single value or range (e.g. 0-10000, >=0, <=10000)"
                        value={remainingAmountFilter}
                        onChange={(e) => setRemainingAmountFilter(e.target.value)}
                        style={{
                          padding: "5px",
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") fetchOrders();
                        }}
                      />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="service_category">
                    <th>
                      <select
                        value={productAppFilter}
                        onChange={(e) => setProductAppFilter(e.target.value)}
                        style={{
                          //  width: "110px",
                          padding: "5px"
                        }}
                      >
                        <option value="">--select--</option>
                        <option value="0">Trade Calls</option>
                        <option value="1">Portfolios</option>
                      </select>
                    </th>
                  </FieldPermissionWrapper>
                  <th>
                    <select
                      value={subscriptionTypeFilter}
                      onChange={(e) =>
                        setSubscriptionTypeFilter(e.target.value)
                      }
                      style={{
                        // width: "110px",
                        padding: "5px"
                      }}
                    >
                      <option value="">--select--</option>
                      {dropdownOptions.orderSubscriptionTypeList &&
                        dropdownOptions.orderSubscriptionTypeList.map(
                          (item, index) => (
                            <option key={index} value={item.value}>
                              {item.label}
                            </option>
                          )
                        )}
                    </select>
                  </th>
                  <FieldPermissionWrapper field="order_status">
                    <th>
                      <select
                        value={refundStatusFilter}
                        onChange={(e) => setRefundStatusFilter(e.target.value)}
                        style={{
                          // width: "110px",
                          padding: "5px"
                        }}
                      >
                        <option value="">--select--</option>
                        {dropdownOptions.refundStatus &&
                          dropdownOptions.refundStatus.map((item, index) => (
                            <option key={index} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                      </select>
                    </th>
                  </FieldPermissionWrapper>
                  <th>
                    <MultiSelectDropdown
                      options={dropdownOptions.paymentSourceList || []}
                      selectedValues={paymentSourceFilter}
                      onChange={(values) => {
                        // Debounce the filter update to prevent multiple rapid calls
                        const timer = setTimeout(() => {
                          // Convert to string values and ensure array format
                          const val = Array.isArray(values)
                            ? values
                                .map((v) =>
                                  v && typeof v === "object" && v.value !== undefined
                                    ? String(v.value)
                                    : String(v)
                                )
                                .filter(
                                  (v) =>
                                    v !== "" &&
                                    v !== "undefined" &&
                                    v !== "null"
                                )
                            : [];
                          setPaymentSourceFilter(val);
                        }, 300);

                        return () => clearTimeout(timer);
                      }}
                      placeholder="--Select--"
                      className="payment-source-dropdown"
                      valueKey="value"
                      displayKey="label"
                    />
                  </th>
                  <FieldPermissionWrapper field="refund_date">
                    <th>
                      <div className="d-flex align-items-center gap-1">
                        <DatePicker
                          selected={refundDateFilter[0]}
                          onChange={handleRefundDateChange}
                          startDate={refundDateFilter[0]}
                          endDate={refundDateFilter[1]}
                          selectsRange
                          isClearable
                          toggleCalendarOnIconClick
                          placeholderText=""
                          monthsShown={3}
                          openToDate={refundDateFilter[0] || new Date()}
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          scrollableYearDropdown
                          yearDropdownItemNumber={15}
                          minDate={new Date(2018, 0, 1)}
                          maxDate={new Date(2030, 11, 31)}
                          dateFormat="dd-MM-yyyy"
                        />
                        <button
                          type="button"
                          className="btn btn-default btn-xs btn-group-xs"
                          onClick={() => fetchOrders()}
                        >
                          <FontAwesomeIcon icon={faSearch} />
                        </button>
                      </div>
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="refund_details">
                    <th></th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="order_sales_manager">
                    <th>
                      <select
                        value={salesManagerFilter}
                        onChange={(e) =>
                          setSalesManagerFilter(e.target.value)
                        }
                        style={{
                          // width: "110px",
                          padding: "5px"
                        }}
                      >
                        <option value="">--select--</option>
                        {dropdownOptions.salesManagerList &&
                          dropdownOptions.salesManagerList.map(
                            (item, index) => (
                              <option key={index} value={item.tu_id}>
                                {" "}
                                {/* Use t3_id as value */}
                                {item.tu_user_fullname}
                              </option>
                            )
                          )}
                      </select>
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="assign_to">
                    <th>
                      <select
                        value={assignedUserFilter}
                        onChange={(e) =>
                          setAssignedUserFilter(e.target.value)
                        }
                        style={{
                          // width: "110px",
                          padding: "5px"
                        }}
                      >
                        <option value="">--select--</option>
                        {dropdownOptions.assignedUserList &&
                          dropdownOptions.assignedUserList.map(
                            (item, index) => (
                              <option key={index} value={item.t3_id}>
                                {item.t3_user_fullname}
                              </option>
                            )
                          )}
                      </select>
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="order_order_approval">
                    <th>
                      <select
                        value={orderApprovalFilter}
                        onChange={(e) =>
                          setOrderApprovalFilter(e.target.value)
                        }
                        style={{
                          // width: "110px",
                          padding: "5px"
                        }}
                      >
                        <option value="">--select--</option>
                        {dropdownOptions.orderApprovallist &&
                          dropdownOptions.orderApprovallist.map(
                            (item, index) => (
                              <option key={index} value={item.value}>
                                {item.label}
                              </option>
                            )
                          )}
                      </select>
                    </th>
                  </FieldPermissionWrapper>
                  <th>
                    <select
                      value={orderTypeFilter}
                      onChange={(e) => setOrderTypeFilter(e.target.value)}
                      style={{
                        // width: "110px",
                        padding: "5px"
                      }}
                    >
                      <option value="">--select--</option>
                      {dropdownOptions.orderTypeList &&
                        dropdownOptions.orderTypeList.map((item, index) => (
                          <option key={index} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                    </select>
                  </th>
                  <FieldPermissionWrapper field="discount_type">
                    <th>
                      <select
                        value={discountTypeFilter}
                        onChange={(e) =>
                          setDiscountTypeFilter(e.target.value)
                        }
                        style={{
                          // width: "110px",
                          padding: "5px"
                        }}
                      >
                        <option value="">--select--</option>
                        {dropdownOptions.offerTypeList &&
                          dropdownOptions.offerTypeList
                            .filter((option) => option.value !== "")
                            .map((item, index) => (
                              <option key={index} value={item.value}>
                                {item.label}
                              </option>
                            ))}
                      </select>
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="discount_code">
                    <th>
                      <input
                        type="text"
                        placeholder=""
                        value={discountCodeFilter}
                        onChange={(e) =>
                          setDiscountCodeFilter(e.target.value)
                        }
                        style={{
                          // width: "90px",
                          padding: "5px",
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") fetchOrders();
                        }}
                      />
                    </th>
                  </FieldPermissionWrapper>
                  <th>
                    <input
                      type="text"
                      placeholder=""
                      value={transactionIdFilter}
                      onChange={(e) => setTransactionIdFilter(e.target.value)}
                      style={{
                        // width: "90px",
                        padding: "5px",
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") fetchOrders();
                      }}
                    />
                  </th>
                  <th>
                    <select
                      value={utmSourceFilter}
                      onChange={(e) => setUtmSourceFilter(e.target.value)}
                      style={{ padding: "5px" }}
                    >
                      <option value="">--select--</option>
                      {(dropdownOptions.utmSourceList || []).map((item, index) => (
                        <option key={index} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </th>
                  <th>
                    <select
                      value={utmMediumFilter}
                      onChange={(e) => setUtmMediumFilter(e.target.value)}
                      style={{ padding: "5px" }}
                    >
                      <option value="">--select--</option>
                      {(dropdownOptions.utmMediumList || []).map((item, index) => (
                        <option key={index} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </th>
                  <th>
                    <select
                      value={utmCampaignFilter}
                      onChange={(e) => setUtmCampaignFilter(e.target.value)}
                      style={{ padding: "5px" }}
                    >
                      <option value="">--select--</option>
                      {(dropdownOptions.utmCampaignList || []).map((item, index) => (
                        <option key={index} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </th>
                  <th>
                    <select
                      value={utmContentFilter}
                      onChange={(e) => setUtmContentFilter(e.target.value)}
                      style={{ padding: "5px" }}
                    >
                      <option value="">--select--</option>
                      {(dropdownOptions.utmContentList || []).map((item, index) => (
                        <option key={index} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </th>
                  <th>
                    <select
                      value={utmTermFilter}
                      onChange={(e) => setUtmTermFilter(e.target.value)}
                      style={{ padding: "5px" }}
                    >
                      <option value="">--select--</option>
                      {(dropdownOptions.utmTermList || []).map((item, index) => (
                        <option key={index} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </th>
                </tr>
              </thead>
              <tbody>
                {loading || dropdownsLoading ? (
                  // Skeleton loading rows 
                  Array.from({ length: 10 }).map((_, skeletonIndex) => (
                    <tr key={`skeleton-${skeletonIndex}`} className="skeleton-row">
                      <td><div className="skeleton-checkbox"></div></td>
                      <td><div className="skeleton-text" style={{ width: "80%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "70%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "85%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "75%" }}></div></td>
                      {/* In the skeleton loading section, add a td for lead source */}
                      <td><div className="skeleton-text" style={{ width: "80%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "80%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "80%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "70%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "90%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "85%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "75%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "80%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "70%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "90%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "85%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "75%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "80%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "70%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "90%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "85%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "75%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "80%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "70%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "90%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "85%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "75%" }}></div></td>
                    </tr>
                  ))
                ) : (
                  filteredOrders.map((order) => {
                    let ordertype = "Child";
                    if (!order.parent || order.parent == 0) {
                      ordertype = "Parent";
                    }
                    return (
                      <tr
                        key={order.id}
                        onClick={() => handleRowClick(order.id)}
                        style={{ cursor: "pointer" }}
                      >
                        <td onClick={(e) => e.stopPropagation()}>
                          <input
                            type="checkbox"
                            checked={selectedOrders.includes(order.id)}
                            onChange={(e) =>
                              handleCheckboxChange(order?.id, e.target.checked)
                            }
                          />
                        </td>
                        <td>
                          {order?.created_on
                            ? moment(order?.created_on).format(
                              "DD-MM-YYYY hh:mm A"
                            )
                            : ""}
                        </td>
                        <td>{order.subscriberorgid}</td>
                        <FieldPermissionWrapper field="lead_source">
                          <td>{order.lead_source || ""}</td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="subscriber_fullname">
                          <td
                            style={{ cursor: "pointer", color: "#0d6efd" }}
                            onMouseEnter={(e) =>
                            (e.currentTarget.style.textDecoration =
                              "underline")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.textDecoration = "none")
                            }
                          >
                            <a
                              href={`/Subscriber/Edit/${order?.subscriberid ||
                                order?.subscriberId ||
                                order?.subscriber_id ||
                                order?.subscriberorgid ||
                                "#"
                                }`}
                              onClick={(e) => {
                                e.preventDefault(); // prevent default navigation
                                e.stopPropagation();
                                const sid =
                                  order?.subscriberid ||
                                  order?.subscriberId ||
                                  order?.subscriber_id ||
                                  order?.subscriberorgid;
                                if (sid) {
                                  navigate(`/Subscriber/Edit/${sid}`);
                                } else {
                                  showToast.warning(
                                    "Subscriber ID not found for this order"
                                  );
                                }
                              }}
                              style={{
                                color: "#0d6efd",
                                textDecoration: "none",
                                display: "block",
                              }}
                            >
                              {order.subscriberfullname}
                            </a>
                          </td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="subscriber_mobileno">
                          <td>{order.subscribermobile}</td>
                        </FieldPermissionWrapper>
                        <td>
                          {order?.payment_date
                            ? moment(order?.payment_date).format(
                              "DD-MM-YYYY hh:mm A"
                            )
                            : ""}
                        </td>
                        <td>
                          {order?.order_due_date
                            ? moment(order?.order_due_date).format("DD-MM-YYYY")
                            : ""}
                        </td>
                        <td>{order.orderid}</td>
                        <FieldPermissionWrapper field="order_paid_amount">
                          <td>{order.amount_payable}</td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="order_actual_amount">
                          <td>{order.actual_amount}</td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="order_discount_amount">
                          <td>{order.discount_amt}</td>
                        </FieldPermissionWrapper>
                        <td>{order.tax_amt}</td>
                        <FieldPermissionWrapper field="remaining_amount">
                          <td>{order.remaining_amt}</td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="service_category">
                          <td>
                            {order.product_app == 0
                              ? "Trade Calls"
                              : order.product_app == 1
                                ? "Portfolios"
                                : ""}
                          </td>
                        </FieldPermissionWrapper>
                        <td>{order.order_subscription_type}</td>
                        <FieldPermissionWrapper field="order_status">
                          <td>
                            {dropdownOptions.refundStatus.find(
                              (option) => option.value == order.order_status
                            )?.label || ""}
                          </td>
                        </FieldPermissionWrapper>
                        <td>
                          {getPaymentSourceLabel(order.payment_source)}
                        </td>
                        <FieldPermissionWrapper field="refund_date">
                          <td>
                            {order?.refund_date
                              ? moment(order?.refund_date).format("DD-MM-YYYY")
                              : ""}
                          </td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="refund_details">
                          <td>{order.refund_details || ""}</td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="order_sales_manager">
                          <td>{order.sales_manager_fullname}</td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="assign_to">
                          <td>{order.user_fullname}</td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="order_order_approval">
                          <td>
                            {order.order_approval == 1 ? "Approved" : "Pending"}
                          </td>
                        </FieldPermissionWrapper>

                        <td>{ordertype}</td>
                        <FieldPermissionWrapper field="discount_type">
                          <td>
                            {order.offer_type == null
                              ? ""
                              : dropdownOptions.offerTypeList.find(
                                (option) => option.value == order.offer_type
                              )?.label || ""}
                          </td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="discount_code">
                          <td>{order.offercode || ""}</td>
                        </FieldPermissionWrapper>
                        <td>{order.transactionid}</td>
                        <td>{order.utm_source || ""}</td>
                        <td>{order.utm_medium || ""}</td>
                        <td>{order.utm_campaign || ""}</td>
                        <td>{order.utm_content || ""}</td>
                        <td>{order.utm_term || ""}</td>
                      </tr>
                    );
                  }))
                }
              </tbody>
              <tfoot>
                <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "bold" }}>
                  <td colSpan="6" style={{ textAlign: "right", padding: "10px" }}>
                    Total:
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <FieldPermissionWrapper field="order_paid_amount">
                    <td style={{ padding: "10px" }}>
                      {parseFloat(orderTotal.amount_payable || 0).toLocaleString('en-IN', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}
                    </td>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="order_actual_amount">
                    <td style={{ padding: "10px" }}>
                      {parseFloat(orderTotal.actual_amount || 0).toLocaleString('en-IN', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}
                    </td>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="order_discount_amount">
                    <td style={{ padding: "10px" }}>
                      {(orderTotal.discount_amt || 0).toLocaleString('en-IN', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}
                    </td>
                  </FieldPermissionWrapper>
                  <td style={{ padding: "10px" }}>
                    {parseFloat(orderTotal.tax_amt || 0).toLocaleString('en-IN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                  </td>
                  <FieldPermissionWrapper field="remaining_amount">
                    <td style={{ padding: "10px" }}>
                      {parseFloat(orderTotal.remaining_amt || 0).toLocaleString('en-IN', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}
                    </td>
                  </FieldPermissionWrapper>
                  <td colSpan="18"></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      {/* Backdrop */}
      {isModalOpenAddOrderModal && (
        <div
          className="modal-backdrop fade show"
          style={{
            backgroundColor: "rgba(0, 0, 0, 1)",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1040,
          }}
        ></div>
      )}

      {/* Modal structure */}
      {isModalOpenAddOrderModal && (
        <AddOrderPopup
          isOpen={isModalOpenAddOrderModal}
          onClose={closeModal}
          onSubmit={handleAddOrderData}
        />
      )}
      {isModalOpenBulkEdit && (
        <div
          className="modal-backdrop fade show"
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1040,
          }}
        ></div>
      )}

      {isModalOpenBulkEdit && (
        <BulkEditOrderPopup
          isOpen={isModalOpenBulkEdit}
          onClose={() => setIsModalOpenBulkEdit(false)}
          selectedOrders={selectedOrders}
          fetchOrders={fetchOrders}
        />
      )}
    </div>
  );
};

export default Order;